import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormRow, FormRowView } from "components/shared";
import { UITextInput } from "components/ui";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayCreateTemplateFileExcludeWidget
 * @return {React.Component}
 * @exported true
 * @description The file exclude widget for the positive pay create template page.
 */
export default function TASPositivePayCreateTemplateFileExcludeWidget(prop) {
    const {data, ui, onChangeCheckTemp } = useStateManager();
    const checkTemplate = data.checkTemplate;
    const textQualifiers = checkTemplate.textQualifiers;
    const textQualifierRows = textQualifiers.reduce((acc, item) => {
        acc.push(
            <CustomSelectItem key={ `${ item.id }`} value={ `${ item.value }`}
            dataPoint={ `TAS_Positive_Pay_Create_Template_File_Exclude_Widget_Text_Qualifier_Option_${ `${ item.id }` }` }>
                { `${ item.label }`}
            </CustomSelectItem>
        );
        return acc;
    }, []);

    return (
        <div className="tas-positive-pay-create-template-file-exclude-widget">
            <h2>Number of Rows to Exclude</h2>
            <FormRow className="header-footer-row flex-horizontal align-center">
                <FormRowView className="header-row" text={
                    <div className="flex-container flex-horizontal align-center">
                        <p className="label-with-icon">Header (Optional)</p>
                        <SVGAsset id="InfoIcon" />
                    </div>
                }>
                    <UITextInput dataPoint={ `TAS_Positive_Pay_Create_Template_File_Exclude_Widget_Number_Of_Header_Rows_Input` }
                    value={ checkTemplate.numberOfRowsToExcludeHeader } onChange={ onChangeCheckTemp("numberOfRowsToExcludeHeader") } />
                </FormRowView>
                <FormRowView className="footer-row" text={
                    <div className="flex-container flex-horizontal align-center">
                        <p className="label-with-icon">Footer (Optional)</p>
                        <SVGAsset id="InfoIcon" />
                    </div>
                }>
                    <UITextInput
                    value={ checkTemplate.numberOfRowsToExcludeFooter } onChange={ onChangeCheckTemp("numberOfRowsToExcludeFooter") }/>
                </FormRowView>
            </FormRow>
            <FormRowView className="text-qualifier-row" text={
                <div className="flex-container flex-horizontal align-center">
                    <p className="label-with-icon">Text Qualifier</p>
                    <SVGAsset id="InfoIcon" />
                </div>
            }>
                <CustomSelect value={ checkTemplate.textQualified }
                active={ ui.checkTemplate.textQualifierDD.isActive } 
                dataPoint={ `TAS_Positive_Pay_Create_Template_File_Exclude_Widget_Text_Qualifier_Select` }
                onChange={ onChangeCheckTemp("textQualified") }>
                    { textQualifierRows }
                </CustomSelect>
            </FormRowView>
        </div>
    )
}
